import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CategoryFilterItemSlide" }
const _hoisted_2 = { class: "RangeSliderBase" }
const _hoisted_3 = ["step", "min", "max"]
const _hoisted_4 = ["step", "min", "max"]
const _hoisted_5 = { class: "CategoryFilterItemSlide-inputs" }
const _hoisted_6 = ["name", "min"]
const _hoisted_7 = ["name", "max"]
const _hoisted_8 = { class: "CategoryFilterItemSlide-unit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "aria-label": "minmax",
        type: "range",
        step: _ctx.rangeStep,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.min) = $event)),
        min: _ctx.getMinimum(),
        max: _ctx.getMaximum(),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeValue({ type: _ctx.data.nameMin, value: _ctx.min }))),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSlide('min'))),
        onMouseup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeValue({ type: _ctx.data.nameMin, value: _ctx.min })))
      }, null, 40, _hoisted_3), [
        [
          _vModelText,
          _ctx.min,
          void 0,
          { number: true }
        ]
      ]),
      _withDirectives(_createElementVNode("input", {
        "aria-label": "minmax",
        type: "range",
        step: _ctx.rangeStep,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.max) = $event)),
        min: _ctx.getMinimum(),
        max: _ctx.getMaximum(),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeValue({ type: _ctx.data.nameMax, value: _ctx.max }))),
        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSlide('max'))),
        onMouseup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeValue({ type: _ctx.data.nameMax, value: _ctx.max })))
      }, null, 40, _hoisted_4), [
        [
          _vModelText,
          _ctx.max,
          void 0,
          { number: true }
        ]
      ]),
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.rangeIndicatorStyle)
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        "aria-label": "min",
        type: "number",
        name: _ctx.data.nameMin,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.min) = $event)),
        min: _ctx.getMinimum(),
        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (this.handleInputChange && this.handleInputChange(...args)))
      }, null, 40, _hoisted_6), [
        [
          _vModelText,
          _ctx.min,
          void 0,
          {
            number: true,
            lazy: true
          }
        ]
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("span", null, "-", -1)),
      _withDirectives(_createElementVNode("input", {
        "aria-label": "max",
        type: "number",
        name: _ctx.data.nameMax,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.max) = $event)),
        max: _ctx.getMaximum(),
        onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (this.handleInputChange && this.handleInputChange(...args)))
      }, null, 40, _hoisted_7), [
        [
          _vModelText,
          _ctx.max,
          void 0,
          {
            number: true,
            lazy: true
          }
        ]
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.data.unit), 1)
    ])
  ]))
}